import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Box } from '@mui/material';

import { COLORS } from '@/styles/tokens/colors';

import { PresentationTemplateBundleTile } from './PresentationTemplateBundleTile';

export interface DraggableBundleTileProps {
  index: number;
  bundleId: string;
}

export function DraggableBundleTile({
  index,
  bundleId,
}: DraggableBundleTileProps) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: bundleId });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <Box
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      sx={{
        backgroundColor: isDragging ? COLORS.GRAY[50] : 'unset',
        borderRadius: isDragging ? 1 : 0,
        cursor: 'grab',
        '&:active': {
          cursor: 'grabbing',
        },
      }}
    >
      <PresentationTemplateBundleTile index={index} />
    </Box>
  );
}
